import { Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SessionService } from '@/core/services/security/session.service';
import { buildMenuItemsFromPermissoes, getPermissoesDoPerfilSelecionado } from '@/core/utils/menu/build-menu-from-permissoes.util';
import { GlobalEvents } from '@/events/global/global.events';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-menu, [app-menu]',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false,
})
export class MenuComponent implements OnInit, OnDestroy {
    el: ElementRef = inject(ElementRef);
    private sessionService = inject(SessionService);
    private globalEvents = inject(GlobalEvents);
    private sessionRestoredSubscription?: Subscription;

    @ViewChild('menuContainer') menuContainer!: ElementRef;

    model: MenuItem[] = [];

    ngOnInit(): void {
        this.loadMenuFromSession();
        this.sessionRestoredSubscription = this.globalEvents.sessionRestored$.subscribe(() => {
            this.loadMenuFromSession();
        });
    }

    ngOnDestroy(): void {
        this.sessionRestoredSubscription?.unsubscribe();
    }

    private loadMenuFromSession(): void {
        const session = this.sessionService.getInstance();
        const permissoes = getPermissoesDoPerfilSelecionado(session?.user);
        this.model = buildMenuItemsFromPermissoes(permissoes, session?.menuModulosFlat);
    }
}
